// extracted by mini-css-extract-plugin
export default {"treatmentPlanDetailsContainer":"ViewTreatmentPlanDetails_treatmentPlanDetailsContainer__f+azC"};